import * as React from 'react'
import { render } from 'react-dom'
import PortalProvider from './components/portal_provider'
import SentryProvidedErrorBoundary from './components/ErrorBoundary'
import appConfig from './bootstrap/app_config'
import configureSentry, {
  isValidPageServiceEnv,
} from './bootstrap/configureSentry'
import LayerManager from '@doordash/component-layer-manager'
import { ToastProvider } from '@doordash/component-toast'
import reduxStore from './store'
import { Colors } from '@doordash/design-language'
import { injectGlobal } from 'styled-components'

injectGlobal`
  body {
    font-family: DD-TTNorms, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    margin: 0;
    background-color: ${Colors.SystemGrey5}
    min-height: 100vh;
    overflow-x: hidden;
    position: relative;
    width: 100%;
  }

  a {
    text-decoration: none
    color: ${Colors.BrandRedBase}
    transition: color .1s ease
  }

  h1 {
    font-weight: bold;
  }
`

/**
 * This main function is being called by the templated rendered in Page Service
 * https://github.com/doordash/page-service/blob/6afdd2de84910abbbce4b51ced3dac2ddd69f20e/views/teams-portal/home.hbs#L55
 * @param {HTMLElement} container an HTML element React will mount as root of the Application
 * @param {Record<string, any>} initialState a JSON object that inject by page service to configure the environment
 */
const main = (container, initialState) => {
  if (initialState.teamsServerUrl) {
    appConfig.SERVER_URL = initialState.teamsServerUrl
  }

  configureSentry({
    env:
      initialState &&
      initialState.environment &&
      isValidPageServiceEnv(initialState.environment)
        ? initialState.environment
        : undefined,
  })

  render(
    <SentryProvidedErrorBoundary>
      <LayerManager>
        <ToastProvider position={ToastProvider.Positions.TopCenter}>
          <PortalProvider reduxStore={reduxStore} />
        </ToastProvider>
      </LayerManager>
    </SentryProvidedErrorBoundary>,
    container
  )
}

global.app = {
  default: main,
}

export default main
